import ArrowsDownToPeopleIcon from '@eversports/design-tokens/assets/icons/regular/arrows-down-to-people.svg'
import Button from '@eversports/klimt-primitives/Button'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Divider from '@eversports/klimt-primitives/legacy/Divider'
import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Svg from '@eversports/klimt-primitives/legacy/Svg'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized, useIntl } from '../../../../localization/react'

import ShareIcon from './assets/icons/arrow-up-from-square.svg'

interface Props {
  venueName: string
  referralCode: string
  rewardDescription: string
  image: string
}

export function VenueReferAFriendOverlayContent({ venueName, referralCode, rewardDescription, image }: Props) {
  const intl = useIntl()

  const handleShare = () => {
    if (typeof navigator === 'undefined' || !navigator.share) return
    void navigator
      .share({
        title: intl.referAFriendVenueDialogShareTitle({ venueName }),
        text: intl.referAFriendVenueDialogShareText({ venueName, referralCode }),
      })
      .catch(() => {
        // user cancelled or share unavailable
      })
  }

  return (
    <Stack gap={4}>
      <Stack direction="row" alignItems="center" gap={2}>
        <Icon src={ArrowsDownToPeopleIcon} size="small" color="midnight" />
        <Heading is="h4" variant="small">
          <Localized id="refer-a-friend-venue-dialog-title" params={{ venueName }} />
        </Heading>
      </Stack>

      <Box
        component="img"
        src={image}
        alt=""
        sx={{
          width: '100%',
          objectFit: 'cover',
          borderRadius: 1,
        }}
      />

      {rewardDescription && (
        <Text variant="small" sx={{ whiteSpace: 'pre-line', color: 'darkgray' }}>
          {rewardDescription}
        </Text>
      )}

      <Divider />

      <Stack gap={1}>
        <Text variant="small" sx={{ fontWeight: 'bold' }}>
          <Localized id="refer-a-friend-venue-dialog-code-label-at-venue" />
        </Text>
        <Button
          variant="tertiary"
          size="sm"
          iconPosition="right"
          onClick={handleShare}
          className="flex items-center gap-2"
        >
          <Text variant="small" sx={{ fontWeight: 'medium', color: 'darkgray' }} className="grow">
            {referralCode}
          </Text>
          <Svg src={ShareIcon} width={12} height={12} color="darkgray" />
        </Button>
      </Stack>
      {/* TODO: implement the navigation when the friend referral hub is merged */}
      <Button variant="primary">Check out your Refer a friend hub</Button>
    </Stack>
  )
}
